export default [
  {
    path: '/destek-talepleri',
    name: 'destek-talepleri',
    component: () => import('./Index.vue'),
    meta: {
      public: false,
      title: 'destek_talepleri.Baslik',
      yetki: { k: [1160002, 1160003, 1160004, 1160008] },
    },
  },
  {
    path: '/destek-talepleri/:uuid',
    name: 'destek-talepleri-detay',
    component: () => import('./components/DestekDetay.vue'),
    meta: {
      public: false,
      title: 'destek_talepleri.TalepDetayi',
      yetki: { k: [1160002, 1160003, 1160004, 1160008] },
      navActiveLink: 'destek-talepleri', // Menüde aktif görünmesi için
    },
  },
]
